import { useQuery } from "@tanstack/react-query";
import { getAuthenticatedApiClient } from "../../../api/apiClient";

export const counterpartyLookupKeys = {
  all: ["counterpartyLookup"] as const,
  names: () => [...counterpartyLookupKeys.all, "names"] as const,
  details: (id: string) =>
    [...counterpartyLookupKeys.all, "details", id] as const
};

/**
 * The full name + id list backing the picker. The backend caches this for 10 minutes and it is
 * the same list for every user, so a long staleTime here avoids refetching it on every visit.
 */
export const useCounterpartyLookupNames = () => {
  return useQuery({
    queryKey: counterpartyLookupKeys.names(),
    queryFn: async () => {
      const apiClient = await getAuthenticatedApiClient();
      const response =
        await apiClient.counterpartyLookupList.counterpartyLookupList();
      return response.data;
    },
    staleTime: 10 * 60 * 1000
  });
};

export const useCounterpartyLookupDetails = (id?: string) => {
  return useQuery({
    queryKey: counterpartyLookupKeys.details(id ?? "not_set"),
    queryFn: async () => {
      const apiClient = await getAuthenticatedApiClient();
      const response =
        await apiClient.counterpartyLookupDetails.counterpartyLookupDetails({
          id: id ?? "id_should_always_exist"
        });
      return response.data;
    },
    enabled: !!id
  });
};
